/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import './HelpView.styles.scss';

interface Props {
  title: any;
  htmlContent: any;
  footerContent?: any;
  linkColor: string;
}

const HelpView: React.FC<Props> = (props) => {
  return (
    <div className="cmp-helpview __theme-profile">
      <style>
        {
          `.cmp-helpview.__theme-profile a {
            color: ${props.linkColor};
          }`
        }
      </style>
      <div className="cmp-helpview-content util-application-frame-forcards-padding">
        <div className="cmp-helpview-title font-title-2">{props.title}</div>

        <div className="cmp-helpview-body font-body">
          {props.htmlContent}
        </div>

        {
          props.footerContent && (
            <div className="cmp-helpview-footer font-caption">
              {props.footerContent}
            </div>
          )
        }
      </div>
    </div>
  );
};

export default HelpView;
